export async function safeFetchJSON(url, { signal } = {}) {
  const res = await fetch(url, { signal });
  let data = null;

  try {
    data = await res.json();
  } catch {
    data = null;
  }

  if (!res.ok) {
    throw new Error(
      data?.message || data?.error || `Request failed (${res.status})`,
    );
  }

  return data;
}

export function isUnresolvedStatus(status) {
  const s = String(status || "")
    .trim()
    .toLowerCase();
  return !["closed", "resolved", "completed", "done"].includes(s);
}

export function normalizeHazards(hazards) {
  if (!Array.isArray(hazards)) return "";
  return hazards
    .map((h) => h?.hazards || h?.name || h)
    .filter(Boolean)
    .join(", ");
}

export function parseDateTimeBoundary(input, endOfDay = false) {
  if (!input) return null;
  const s = String(input).trim();
  const hasTime = /T|\d{1,2}:\d{2}/.test(s);
  const d = new Date(
    hasTime ? s : `${s}T${endOfDay ? "23:59:59" : "00:00:00"}`,
  );
  return Number.isNaN(d.getTime()) ? null : d;
}

export function getOpenStartDate(item) {
  return item?.openedAt || item?.date || null;
}

export function getAssigneeIds(item) {
  const arr = Array.isArray(item?.assignedTo)
    ? item.assignedTo
    : item?.assignedTo
      ? [item.assignedTo]
      : [];

  return arr.map((a) => (typeof a === "object" ? a._id : a)).filter(Boolean);
}

export function getAssigneeNames(item) {
  const arr = Array.isArray(item?.assignedTo)
    ? item.assignedTo
    : item?.assignedTo
      ? [item.assignedTo]
      : [];

  return arr
    .map((a) => (typeof a === "object" ? a.name || a.userId || "" : ""))
    .filter(Boolean);
}

export function getAssigneeObjById(item, id) {
  const arr = Array.isArray(item?.assignedTo)
    ? item.assignedTo
    : item?.assignedTo
      ? [item.assignedTo]
      : [];

  const found = arr.find(
    (a) => String(typeof a === "object" ? a?._id : a) === String(id),
  );
  return typeof found === "object" ? found : null;
}

export function toNumberSafe(value, fallback = 0) {
  const n = Number(value);
  return Number.isFinite(n) ? n : fallback;
}

export function getSlaHours(item) {
  return toNumberSafe(item?.riskValue?.alertTimeline, 0);
}

export function getDueAt(item) {
  const opened = getOpenStartDate(item);
  const hours = getSlaHours(item);
  if (!opened || !hours) return null;

  return new Date(new Date(opened).getTime() + hours * 60 * 60 * 1000);
}

export function getDueMeta(item) {
  const dueAt = getDueAt(item);
  if (!dueAt) return { dueAt: null, overdue: false };

  return {
    dueAt,
    overdue: Date.now() > dueAt.getTime(),
  };
}

export function formatDuration(ms) {
  if (!Number.isFinite(ms)) return "—";

  const abs = Math.abs(ms);
  const days = Math.floor(abs / (24 * 3600e3));
  const hours = Math.floor((abs % (24 * 3600e3)) / 3600e3);
  const mins = Math.floor((abs % 3600e3) / 60e3);

  if (days > 0) return `${days}d ${hours}h`;
  if (hours > 0) return `${hours}h ${mins}m`;
  return `${mins}m`;
}
